export default (function (value) {
  return typeof value === 'function';
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isFunction.js
// module id = 422
// module chunks = 0